export const getBulkUploadSuccessHandler = (
  _addSinglePlayer: (player?: any) => void,
  refreshPlayers?: () => void,
) => refreshPlayers;
